enum ReportDataTypes {
  Percentage,
  Currency,
  Text,
  Years,
  None
}

const reportTypeMap: { [key: string]: ReportDataTypes } = {
  // Location
  address: ReportDataTypes.Text,
  unit: ReportDataTypes.Text,
  city: ReportDataTypes.Text,
  state: ReportDataTypes.Text,
  zip: ReportDataTypes.Text,
  // Purchase information
  purchasePrice: ReportDataTypes.Currency,
  salesCommission: ReportDataTypes.Percentage,
  downPayment: ReportDataTypes.Percentage,
  interestRate: ReportDataTypes.Percentage,
  term: ReportDataTypes.Years,
  closingCosts: ReportDataTypes.Currency,
  rehabCost: ReportDataTypes.Currency,
  arv: ReportDataTypes.Currency,
  taxes: ReportDataTypes.Currency,
  insurance: ReportDataTypes.Currency,
  pmi: ReportDataTypes.Currency,
  furnishings: ReportDataTypes.Currency,
  // Revenue and occupancy
  nightlyRevenue: ReportDataTypes.Currency,
  occupancy: ReportDataTypes.Percentage,
  // Expenses
  electricity: ReportDataTypes.Currency,
  internet: ReportDataTypes.Currency,
  utilities: ReportDataTypes.Currency,
  gas: ReportDataTypes.Currency,
  hoaFees: ReportDataTypes.Currency,
  maintenance: ReportDataTypes.Percentage,
  capitalExpenditures: ReportDataTypes.Percentage,
  bookingPlatformFees: ReportDataTypes.Percentage,
  managementFees: ReportDataTypes.Percentage,
  cleaningFees: ReportDataTypes.Currency,
  cleansPerMonth: ReportDataTypes.None,
  landscaping: ReportDataTypes.Currency,
  snowRemoval: ReportDataTypes.Currency,
  pestControl: ReportDataTypes.Currency,
  legalFees: ReportDataTypes.Currency,
  permitAndLicenseFees: ReportDataTypes.Currency,
  // Growth rates
  appreciation: ReportDataTypes.Percentage,
  revenueGrowthRate: ReportDataTypes.Percentage,
  expenseGrowthRate: ReportDataTypes.Percentage,
  // Single Report
  principal: ReportDataTypes.Currency,
  monthlyPaymentWithTaxesAndInsurance: ReportDataTypes.Currency,
  sumOfPayments: ReportDataTypes.Currency,
  interestCost: ReportDataTypes.Currency,
  cashToClose: ReportDataTypes.Currency,
  // Monthly Report
  monthlyRevenues: ReportDataTypes.Currency,
  monthlyExpenses: ReportDataTypes.Currency,
  monthlyCashFlow: ReportDataTypes.Currency,
  // Annual Report
  annualRevenues: ReportDataTypes.Currency,
  annualExpenses: ReportDataTypes.Currency,
  annualCashFlow: ReportDataTypes.Currency,
  homeValues: ReportDataTypes.Currency,
  principalsRemaining: ReportDataTypes.Currency,
  equities: ReportDataTypes.Currency,
  equityLessCashInvested: ReportDataTypes.Currency,
  cumulativeCashFlowForLoanTerm: ReportDataTypes.Currency,
  profitsAtSale: ReportDataTypes.Currency,
  totalReturns: ReportDataTypes.Currency,
  cashOnCashReturn: ReportDataTypes.Percentage,
  simpleROI: ReportDataTypes.Percentage,
  capRate: ReportDataTypes.Percentage,
  // Chart values
  monthlyFees: ReportDataTypes.Currency
};

export function formatValue(key: string, value: any): string {
  const inputType = reportTypeMap[key];

  switch (inputType) {
    case ReportDataTypes.Currency:
      return `${currencyFormatter(value)}`;
    case ReportDataTypes.Percentage:
      return `${percentageFormatter(value)}`;
    case ReportDataTypes.Years:
      return `${value} years`;
    default:
      return value;
  }
}

export const currencyFormatter = (value: any) => {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0
  });
  return formatter.format(!isNaN(value) ? Number(value) : 0);
};

export const percentageFormatter = (value: any) => {
  return !isNaN(value)
    ? Number(value / 100).toLocaleString(undefined, {
        style: 'percent',
        maximumFractionDigits: 0
      })
    : 0;
};
